(function () {
	'use strict';

	function moneyEl(root) { return root.querySelector('[data-price]'); }

	function initSection(section) {
		var sectionId = section.getAttribute('data-section-id');
		var variants = [];
		var dataEl = section.querySelector('[data-pdp-variants]');
		if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

		/* ---- Per-variant content (descriptor / buybox body / size-limited accordion rows + Why touts) ---- */
		var contentMap = {};
		var contentEl = section.querySelector('[data-pdp-content]');
		if (contentEl) { try { contentMap = JSON.parse(contentEl.textContent); } catch (e) { contentMap = {}; } }
		var descriptorEl = section.querySelector('[data-descriptor]');
		var buyboxBodyEl = section.querySelector('[data-body]');
		/* The Why touts live in their own section (m1o2-pdp-why), hence the document-level query. */
		var sizeRows = Array.prototype.slice.call(section.querySelectorAll('[data-acc-only]'))
			.concat(Array.prototype.slice.call(document.querySelectorAll('.m1o2-pdp-why__tout[data-acc-only]')));
		var mainForm = section.querySelector('[data-pdp-form]');
		/* Main ADD TO CART: AJAX-add + open the cart drawer (was a native submit that
		   redirected to /cart and, in preview, dropped preview_theme_id). */
		if (mainForm) { wireAjaxAdd(mainForm); }

		function wireAjaxAdd(bform) {
			if (bform.getAttribute('data-ajax-wired')) { return; }
			bform.setAttribute('data-ajax-wired', '1');
			bform.addEventListener('submit', function (e) {
				e.preventDefault();
				// Prefer the real ATC; the main form may hold size pills (type=button) before it.
				var btn = bform.querySelector('[data-atc]') || bform.querySelector('button[type="submit"]') || bform.querySelector('button');
				// Only text-swap PLAIN buttons - the main ATC nests a <span data-price> that
				// variant changes update, so we must not clobber its innerHTML.
				var plain = btn && btn.children.length === 0;
				var orig = plain ? btn.textContent : '';
				function restore() { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); if (plain) { btn.textContent = orig; } } }
				if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (plain) { btn.textContent = 'ADDING…'; } }
				var drawer = document.querySelector('cart-drawer');
				var params = new URLSearchParams(new FormData(bform));
				if (drawer && typeof drawer.renderContents === 'function') {
					params.append('sections', 'cart-drawer');
					params.append('sections_url', window.location.pathname);
				}
				fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
					body: params.toString()
				}).then(function (r) { return r.json(); }).then(function (data) {
					if (data && data.status) { throw new Error(data.description || data.message || 'add failed'); }
					document.dispatchEvent(new CustomEvent('m1o2:cart:added'));
					// Re-render + slide open the Dawn cart drawer (stays on page, keeps preview).
					if (drawer && data.sections && typeof drawer.renderContents === 'function') {
						// Adding to a previously-empty cart: clear is-empty so Dawn's open()/trapFocus
						// targets the populated #CartDrawer instead of the removed .drawer__inner-empty.
						drawer.classList.remove('is-empty');
						drawer.renderContents(data);
						restore();
					} else {
						if (plain && btn) { btn.textContent = 'ADDED ✓'; }
						setTimeout(restore, 1400);
					}
				}).catch(function (err) {
					restore();
					if (window.console) { console.error('m1o2 cart add failed', err); }
				});
			});
		}

		function applyVariantContent(option1) {
			/* Accordion rows / touts limited to one size (m1o2_accordion / m1o2_tout only_for) */
			sizeRows.forEach(function (row) { row.hidden = row.getAttribute('data-acc-only') !== option1; });
			var data = contentMap[option1];
			if (!data) return;
			/* Top of buybox: descriptor line ("… - Large Size 120mL") + short body copy */
			if (descriptorEl && typeof data.descriptor === 'string' && data.descriptor) {
				descriptorEl.textContent = data.descriptor;
			}
			if (buyboxBodyEl && typeof data.buybox_body === 'string' && data.buybox_body) {
				// Same metafield/description HTML the server renders unescaped into this .rte
				buyboxBodyEl.innerHTML = data.buybox_body;
			}
		}

		/* ---- Gallery: thumb click swaps main ---- */
		var hero = section.querySelector('.m1o2-pdp-main__hero-img');
		var thumbs = Array.prototype.slice.call(section.querySelectorAll('.m1o2-pdp-main__thumb'));
		function selectThumb(btn) {
			if (!hero) return;
			hero.src = btn.getAttribute('data-full');
			var set = btn.getAttribute('data-full-2x');
			if (set) { hero.srcset = set; }
			var alt = btn.getAttribute('data-alt');
			if (alt) { hero.alt = alt; }
			thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
			btn.classList.add('is-active');
			btn.setAttribute('aria-selected', 'true');
		}
		function visibleThumbs() { return thumbs.filter(function (t) { return !t.hidden; }); }
		thumbs.forEach(function (btn) {
			btn.addEventListener('click', function () { selectThumb(btn); });
			btn.addEventListener('keydown', function (e) {
				var vis = visibleThumbs();
				var i = vis.indexOf(btn);
				if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var n = vis[i + 1] || vis[0]; n.focus(); selectThumb(n); }
				else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var p = vis[i - 1] || vis[vis.length - 1]; p.focus(); selectThumb(p); }
			});
		});

		/* ---- Variant switching via size pills ---- */
		var form = section.querySelector('[data-pdp-form]');
		var idInput = section.querySelector('[data-variant-id]');
		var pills = Array.prototype.slice.call(section.querySelectorAll('.m1o2-pdp-main__pill'));
		var atc = section.querySelector('[data-atc]');
		var soldout = section.querySelector('[data-soldout]');
		var sizeValue = section.querySelector('.m1o2-pdp-main__size-label-value');
		var priceSpan = atc ? moneyEl(atc) : null;

		function findVariant(id) {
			for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
			return null;
		}
		function selectVariant(id) {
			var v = findVariant(id);
			if (!v) return;
			if (idInput) idInput.value = v.id;
			pills.forEach(function (p) {
				var on = String(p.getAttribute('data-variant')) === String(id);
				p.classList.toggle('is-active', on);
				p.setAttribute('aria-pressed', on ? 'true' : 'false');
			});
			if (priceSpan && v.price) priceSpan.textContent = v.price;
			if (sizeValue && typeof v.size_label === 'string' && v.size_label) sizeValue.textContent = v.size_label;
			/* Variant image. Prefer driving the matching THUMB, so the hero and the
			   thumb highlight stay in sync (a bare hero.src swap left the old thumb
			   ringed as active). Falls back to re-pointing the hero when the variant's
			   media has no thumb - the gallery renders at most 6 - and then clears the
			   stale highlight. A variant with NO image assigned in the admin leaves the
			   current image alone: there is nothing to switch to. */
			var vThumb = v.media_id ? section.querySelector('.m1o2-pdp-main__thumb[data-media-id="' + v.media_id + '"]') : null;
			if (vThumb) {
				selectThumb(vThumb);
			} else if (hero && v.img) {
				hero.src = v.img;
				if (v.img_set) { hero.srcset = v.img_set; }
				thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
			}
			/* availability */
			if (atc && soldout) {
				if (v.available) { atc.hidden = false; soldout.hidden = true; }
				else { atc.hidden = true; soldout.hidden = false; }
			}
			/* Alert Me modal follows the selected (sold-out) size */
			if (v.img) Array.prototype.forEach.call(section.querySelectorAll('[data-alert-img]'), function (im) { im.src = v.img; im.removeAttribute('srcset'); });
			var alertVariant = section.querySelector('[data-alert-variant]');
			if (alertVariant && v.option1) alertVariant.value = v.option1;
			/* descriptor / body / size-limited accordion rows + touts - client-side swap */
			applyVariantContent(v.option1);
			/* URL ?variant= sync */
			try {
				var url = new URL(window.location.href);
				url.searchParams.set('variant', v.id);
				window.history.replaceState({}, '', url.toString());
			} catch (e) {}
			/* Hook for isolated add-ons (e.g. m1o2-pdp-variant-media.js). */
			section.dispatchEvent(new CustomEvent('m1o2:variant-change', { detail: { variant: v } }));
		}
		pills.forEach(function (p) {
			p.addEventListener('click', function () { selectVariant(p.getAttribute('data-variant')); });
		});

		/* ---- Rating badge → scroll to the Testimonials section ----
		   Judge.me injects the badge after load, so delegate from the rating wrapper.
		   Capture phase + stopPropagation pre-empts Judge.me's own handler, which
		   targets its default review-widget anchor rather than our section. */
		var rating = section.querySelector('.m1o2-pdp-main__rating');
		function scrollToReviews(e) {
			if (!e.target.closest('.jdgm-prev-badge')) return;
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
			var target = document.querySelector('.M1o2-pdp-Testimonials_section');
			if (!target) return;
			e.preventDefault();
			e.stopPropagation();
			target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		if (rating) {
			rating.addEventListener('click', scrollToReviews, true);
			rating.addEventListener('keydown', scrollToReviews, true);
		}

		/* ---- Wishlist heart ----
		   The live store runs the Wishlist by Square app embed, which injects its own button
		   (.Vtl-WishlistButtonWrapper) into the info column on top of this heart. The Figma
		   heart stays the visible control and drives the app: a click presses the app's
		   (visually hidden) button, and the heart's state mirrors the app's
		   .Vtl-WishlistButton--active. The app injects late and may re-render, so a
		   MutationObserver keeps both in step. Without the app (theme dev, app disabled)
		   the heart falls back to a localStorage list. */
		var wish = section.querySelector('.m1o2-pdp-main__wishlist');
		if (wish) {
			var handle = wish.getAttribute('data-handle');
			var key = 'm1o2:wishlist';
			var list = [];
			try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }

			function setWish(on) {
				wish.setAttribute('aria-pressed', on ? 'true' : 'false');
				wish.classList.toggle('is-active', on);
			}
			function appWrapper() {
				return section.querySelector('.Vtl-WishlistButtonWrapper');
			}
			function syncFromApp() {
				var wrap = appWrapper();
				if (!wrap) return;
				/* One control for keyboard and screen-reader users: ours. */
				if (wrap.getAttribute('aria-hidden') !== 'true') wrap.setAttribute('aria-hidden', 'true');
				var press = wrap.querySelector('.Vtl-WishlistButton__AddToWishlist');
				if (press && press.getAttribute('tabindex') !== '-1') press.setAttribute('tabindex', '-1');
				setWish(!!wrap.querySelector('.Vtl-WishlistButton--active'));
			}

			if (list.indexOf(handle) !== -1) setWish(true);
			syncFromApp();
			if ('MutationObserver' in window) {
				new MutationObserver(syncFromApp).observe(section, {
					childList: true,
					subtree: true,
					attributes: true,
					attributeFilter: ['class']
				});
			}

			wish.addEventListener('click', function () {
				var press = appWrapper() && appWrapper().querySelector('.Vtl-WishlistButton__AddToWishlist');
				if (press) {
					press.click();
					return;
				}
				var on = wish.getAttribute('aria-pressed') !== 'true';
				setWish(on);
				var idx = list.indexOf(handle);
				if (on && idx === -1) list.push(handle);
				if (!on && idx !== -1) list.splice(idx, 1);
				try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
			});
		}

		/* ---- Subscribe & Save toggle + cadence ---- */
		var ssCheck = section.querySelector('[data-ss-toggle]');
		var ssPanel = section.querySelector('[data-ss-panel]');
		var planInput = section.querySelector('[data-selling-plan]');
		var cadencePills = Array.prototype.slice.call(section.querySelectorAll('.m1o2-pdp-main__cadence-pill'));
		function applyPlan() {
			if (!planInput) return;
			var subscribing = ssCheck && ssCheck.checked;
			var active = section.querySelector('.m1o2-pdp-main__cadence-pill.is-active');
			var planId = active ? active.getAttribute('data-plan') : '';
			if (subscribing && planId) { planInput.value = planId; planInput.disabled = false; }
			else { planInput.value = ''; planInput.disabled = true; }
		}
		if (ssCheck && ssPanel) {
			ssCheck.addEventListener('change', function () {
				ssPanel.hidden = !ssCheck.checked;
				applyPlan();
			});
		}
		cadencePills.forEach(function (c) {
			c.addEventListener('click', function () {
				cadencePills.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
				c.classList.add('is-active'); c.setAttribute('aria-pressed', 'true');
				var interval = section.querySelector('[data-ss-interval]');
				if (interval && c.getAttribute('data-interval')) interval.textContent = c.getAttribute('data-interval');
				applyPlan();
			});
		});

		/* ---- Accordions ---- */
		Array.prototype.slice.call(section.querySelectorAll('.m1o2-pdp-main__acc-head')).forEach(function (head) {
			head.addEventListener('click', function () {
				var expanded = head.getAttribute('aria-expanded') === 'true';
				head.setAttribute('aria-expanded', expanded ? 'false' : 'true');
				var panel = document.getElementById(head.getAttribute('aria-controls'));
				if (panel) panel.hidden = expanded;
			});
		});

		/* ---- Bundle AJAX add (server-rendered cards; regenerated cards re-wire via wireAjaxAdd above) ---- */
		Array.prototype.slice.call(section.querySelectorAll('[data-ajax-add]')).forEach(wireAjaxAdd);

		/* ---- Alert Me modal ---- */
		var modal = section.querySelector('[data-alert-modal]');
		if (modal) {
			var openBtn = section.querySelector('[data-alert-open]');
			var closeEls = Array.prototype.slice.call(modal.querySelectorAll('[data-alert-close]'));
			var dialog = modal.querySelector('.m1o2-pdp-modal__dialog');
			var lastFocus = null;
			function openModal() {
				lastFocus = document.activeElement;
				modal.hidden = false;
				document.body.classList.add('m1o2-pdp-lock');
				if (dialog) dialog.focus();
			}
			function closeModal() {
				modal.hidden = true;
				document.body.classList.remove('m1o2-pdp-lock');
				if (lastFocus && lastFocus.focus) lastFocus.focus();
			}
			/* STOQ back-in-stock app embed injects its own "Notify me when available" button.
			   It is hidden and our own styled button drives it instead, so sign-ups still land
			   in STOQ; without STOQ on the page the button falls back to our contact modal.
			   Matched by text, not class - STOQ's markup is not ours and is injected late. */
			var stoqBtn = null;
			function findStoq() {
				/* Keep the trigger already found; STOQ's popup submit can carry the same label and
				   must stay visible, so nothing inside a dialog or an email form is ever hidden. */
				if (stoqBtn && document.contains(stoqBtn)) return;
				var els = document.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]');
				for (var i = 0; i < els.length; i++) {
					var el = els[i];
					if (el === openBtn || el.closest('[data-soldout], [data-alert-modal]')) continue;
					if (el.closest('dialog, [role="dialog"], [aria-modal="true"]')) continue;
					var elForm = el.closest('form');
					if (elForm && elForm.querySelector('input[type="email"]')) continue;
					var txt = (el.textContent || el.value || '').replace(/\s+/g, ' ').trim();
					if (/notify me when available/i.test(txt)) {
						el.classList.add('m1o2-stoq-hidden');
						stoqBtn = el;
						break;
					}
				}
			}
			findStoq();
			if (window.MutationObserver) {
				var stoqTimer = null;
				new MutationObserver(function () {
					clearTimeout(stoqTimer);
					stoqTimer = setTimeout(findStoq, 50);
				}).observe(document.body, { childList: true, subtree: true });
			}
			if (openBtn) openBtn.addEventListener('click', function () {
				if (stoqBtn && document.contains(stoqBtn)) stoqBtn.click();
				else openModal();
			});
			closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape' && !modal.hidden) closeModal();
			});
			/* focus trap */
			modal.addEventListener('keydown', function (e) {
				if (e.key !== 'Tab' || modal.hidden) return;
				var focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
				focusable = Array.prototype.filter.call(focusable, function (el) { return el.offsetParent !== null || el === dialog; });
				if (!focusable.length) return;
				var first = focusable[0], last = focusable[focusable.length - 1];
				if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
				else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
			});
			/* email validation for error state */
			var alertForm = modal.querySelector('.m1o2-pdp-modal__form');
			var emailInput = modal.querySelector('[data-alert-email]');
			var errorEl = modal.querySelector('[data-alert-error]');
			/* Error state = Figma 1647:19335: red line under ALERT ME, cleared as soon as the
			   visitor edits the address. The typed address is stashed so the thank-you panel
			   (rendered after the contact post reloads the page) can repeat it back. */
			var EMAIL_KEY = 'm1o2-alert-email';
			function setError(on) {
				if (errorEl) errorEl.hidden = !on;
				if (on) emailInput.setAttribute('aria-invalid', 'true');
				else emailInput.removeAttribute('aria-invalid');
			}
			if (alertForm && emailInput) {
				alertForm.addEventListener('submit', function (e) {
					var val = emailInput.value.trim();
					var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
					if (!ok) { e.preventDefault(); setError(true); emailInput.focus(); return; }
					setError(false);
					try { sessionStorage.setItem(EMAIL_KEY, val); } catch (err) {}
				});
				emailInput.addEventListener('input', function () { if (errorEl && !errorEl.hidden) setError(false); });
			}
			/* re-open in thank-you state after a successful contact post */
			if (modal.querySelector('[data-alert-posted]')) {
				var formPanel = modal.querySelector('[data-alert-panel-form]');
				var thanksPanel = modal.querySelector('[data-alert-panel-thanks]');
				var thanksCopy = modal.querySelector('[data-alert-thanks-copy]');
				var sent = null;
				try { sent = sessionStorage.getItem(EMAIL_KEY); sessionStorage.removeItem(EMAIL_KEY); } catch (err) {}
				if (thanksCopy && sent) {
					thanksCopy.textContent = 'We will email you at ' + sent + ' when this product is back in stock!';
				}
				if (formPanel) formPanel.hidden = true;
				if (thanksPanel) {
					thanksPanel.hidden = false;
					var thanksTitle = thanksPanel.querySelector('.m1o2-pdp-modal__title');
					if (thanksTitle && thanksTitle.id && dialog) dialog.setAttribute('aria-labelledby', thanksTitle.id);
				}
				openModal();
			}
		}
	}

	/* ---- Coupon line, filled from the nav announcement bar ----
	   The utility row's coupon setting is a template ("Get XX% with code XXXXXX"); the real
	   percent and code come from the header's coupon text (sections/m1o2-nav.liquid), e.g.
	   "25% off your first order with code: COURTNEYY25", so one edit in the header updates
	   both. The code is the word after "code", else the last ALL-CAPS/digit token. Without a
	   bar, or without both values, the line stays hidden rather than showing placeholders. */
	function readNavCoupon() {
		var el = document.querySelector('.m1o2-nav__coupon-text');
		if (!el) return null;
		var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
		var pct = text.match(/(\d+(?:\.\d+)?)\s*%/);
		var code = text.match(/\bcode\b\s*:?\s*([A-Za-z0-9_-]{3,})/i);
		if (!code) {
			var caps = text.match(/\b[A-Z0-9][A-Z0-9_-]{3,}\b/g);
			code = caps ? [null, caps[caps.length - 1]] : null;
		}
		if (!pct || !code) return null;
		return { percent: pct[1] + '%', code: code[1] };
	}

	function initCouponLines() {
		var lines = document.querySelectorAll('[data-m1o2-coupon-line]');
		if (!lines.length) return;
		var coupon = readNavCoupon();
		Array.prototype.forEach.call(lines, function (line) {
			var out = line.querySelector('[data-m1o2-coupon-text]');
			var template = line.getAttribute('data-template') || '';
			if (!coupon || !out || !template) { line.hidden = true; return; }
			out.textContent = template.replace('XX%', coupon.percent).replace('XXXXXX', coupon.code);
			line.hidden = false;
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		Array.prototype.slice.call(document.querySelectorAll('.m1o2-pdp-main')).forEach(initSection);
		initCouponLines();
	});
})();
